







































import Vue from 'vue'

export default Vue.extend({
  name: 'AccountButtons',
  computed: {
    isSignedIn() {
      return this.$store.state.authentication.signedIn
    },
    userName() {
      return this.$store.state.authentication.user.firstname
    },
    avatar() {
      return this.$store.state.authentication.user.avatar
    },
    nickname() {
      return this.$store.state.authentication.user.nickname
    },
    isAmbassador() {
      return this.$store.state.authentication.user.isAmbassador
    },
  },
  data: () => ({}),
  methods: {
    signOut: function () {
      this.$store.dispatch('authentication/signOut', {
        api: this.$api,
      })
    },
  },
})
